import React from "react";
import { useTranslation } from "react-i18next";

import CardColumn from "components/CardColumn";

interface Props {
	name: string;
	type: string;
	value: string;
}

const VariableCard = ({ name, type, value }: Props) => {
	const { t } = useTranslation();

	return (
		<>
			<CardColumn width="lg">
				<div className="variables__card--mobile--heading__name">
					{t("main.variables.headings.name")}
				</div>
				<div>{name}</div>
			</CardColumn>
			<CardColumn width="lg">
				<div className="variables__card--mobile--heading__type">
					{t("main.variables.headings.type")}
				</div>
				<div>{type}</div>
			</CardColumn>
			<CardColumn width="xl">
				<div className="variables__card--mobile--heading__value">
					{t("main.variables.headings.value")}
				</div>
				<div>{value}</div>
			</CardColumn>
		</>
	);
};

export default VariableCard;
